export enum LayoutProductPriceDisplay {
  BOTH = "BOTH",
  UNIT_PRICE = "UNIT_PRICE",
  TAKEAWAY_PRICE = "TAKEAWAY_PRICE",
}
